module.exports = __webpack_public_path__ + "static/media/Graceling.2845ca51.jpg";